<template>
  <div class="scanning">
    <div class="scanning__content">
      <div class="scanning__content-loading">
        <img src="@/assets/images/pos/spinner.gif"/>
      </div>
      <div class="scanning__content-title">
        Scanning QR Code...
      </div>
    </div>
  </div>
</template>
<script>
export default {}
</script>
